import React from 'react';
import type { Key } from '@adobe/react-spectrum';
import { Control } from 'react-hook-form/dist/types';

import { FormItem, FormLabel, FormControl, FormField } from '@/components/v2/Form/Form';
import { OrganizationDto } from '@/features/organizations/types';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/v2/Form/Select';

interface HostOrgSelectInputProps {
  control: Control<
    {
      conferenceName: string;
      hostOrg: string;
      announcements?: string | undefined;
    },
    object
  >;
  hostOrgs: OrganizationDto[] | undefined;
  selectedParentOrg: Key;
}

export const HostOrgSelectInput = ({
  control,
  selectedParentOrg,
  hostOrgs,
}: HostOrgSelectInputProps) => (
  <FormField
    control={control}
    name="hostOrg"
    render={({ field }) => (
      <FormItem>
        <FormLabel aria-required>Host organization</FormLabel>
        <Select
          disabled={selectedParentOrg === ''}
          onValueChange={field.onChange}
          defaultValue={field.value}
          value={field.value}>
          <FormControl>
            <SelectTrigger>
              <SelectValue placeholder="Select host organization" />
            </SelectTrigger>
          </FormControl>
          <SelectContent>
            {hostOrgs?.map((org) => (
              <SelectItem key={org.id} value={org.id}>
                {`${org.name} ${selectedParentOrg === org.id ? '(default)' : ''}`}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormItem>
    )}
  />
);
